// Attributes for animation
$(function(){
  $('.item__text').attr('data-sr','enter bottom 0.5s');
  $('.item__image').attr('data-sr', 'enter top 0.5s');

  // Offset scroller (in px) for fixed top navigation
  $.scrollIt({
    topOffset:-140
  });
  
  // scrollReveal default Config for image entrance
  var config = {
    enter: 'top',
    over: '1s',
    move: '20px',
    wait: '1s',
    easing: 'ease',
    reset:  false,
    delay:  'onload',
    vFactor: 0.30
  };

  window.sr = new scrollReveal( config );
  
});
